import React from 'react';
import styled from 'styled-components';

import { Row, Col, FlexView, COLORS, Separator } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';

const FoldingWrapper = styled(FlexView)`
  position: absolute;
  right: 0;
  /* width: 50px;
  height: 50px;
  border-left-width: 0;
  border-right-width: 1px;
  border-bottom-width: 1px;
  border-right-color: ${COLORS.WHITE};
  border-bottom-color: ${({ color }) => color};
  border-bottom-left-radius: 16px; */
  width: 50px;
  height: 50px;
  background: ${({ color }) => ` linear-gradient(to top right,${color} 50%,white 50%)`};
  border-bottom-left-radius: 16px;

`;

const Wrapper = styled(FlexView)`
  position: relative;
  background: ${({ color }) => color};
  border-bottom-right-radius: 2px;
  border-bottom-left-radius: 2px;
`;

const Circle = styled(FlexView)`
  height: 10px;
  width: 10px;
  margin-top: 10px;
  border: 1px solid ${({ borderColor }) => borderColor};
  border-radius: 16px;
  border-width: 2px;
  border-color: ${({ borderColor }) => borderColor};
  background: ${({ backgroundColor }) => backgroundColor};
`;

const HeadingWrapper = styled(FlexView)`
  width: fit-content;
  padding: 4px 12px;
  background: ${({ color }) => color};
  border-bottom-right-radius: 16px;
`;

const InfoWrapper = styled(FlexView)`
  padding: 12px 32px 16px 12px;
`;

function StrategyCard({ heading, color, data = [] }) {
  const [color1, color2, color3] = color;

  return (
    <Wrapper color={color1}>
      <HeadingWrapper color={color2}>
        <Text variant="eyebrow2">{heading}</Text>
      </HeadingWrapper>
      <InfoWrapper>
        {data.map(({ option_info: optionInfo, option_label: optionLabel }, idx) => (
          <React.Fragment key={optionLabel}>
            <Row>
              <Col>
                <Circle borderColor={color3} backgroundColor={color1} />
              </Col>
              <Col auto>
                <Text variant="body1Medium">{optionLabel}</Text>
                <Separator height={4} transparent />
                <Text variant="body2">{optionInfo}</Text>
              </Col>
            </Row>
            <Separator height={12} transparent />
          </React.Fragment>
        ))}
      </InfoWrapper>
      <FoldingWrapper color={color2} />
    </Wrapper>
  );
}

export default StrategyCard;
